import { statusDefaultTextValue } from '@shared/constants';
import { RemovePillData } from '@shared/interfaces';
import { Subject } from 'rxjs';
import { FilterPill } from './table-filter-pill.class';

export class StatusFilter extends FilterPill {
    private composeFilterPillsMultiselectValues(filterValues: number[], textValues: Record<number, string>) {
        return filterValues.map(v => {
            const label = textValues[v];

            return {
                label,
                value: v,
            };
        });
    }
    private removeMultiselectFilter(data: RemovePillData, multiFilter: number[]) {
        if (data.removeAll) {
            return [statusDefaultTextValue.value];
        } else {
            const result = multiFilter;
            const index = multiFilter.findIndex(el => el === data.id);
            result.splice(index, 1);
            return [...result];
        }
    }
    override updateState(statusFilterValue: number[], statusNames: Record<number, string>, debounce?: Subject<void>) {
        this.hasOverlay = statusFilterValue.length > 1;
        this.isRemovable = statusFilterValue.length > 1 || !statusFilterValue.includes(statusDefaultTextValue.value);
        this.values = this.composeFilterPillsMultiselectValues(statusFilterValue, statusNames);
        this.onRemove = data => {
            const newValues = this.removeMultiselectFilter(data, statusFilterValue);
            this.updateState(newValues, statusNames, debounce);
            debounce?.next();
        };
        this.isVisible = !!statusFilterValue.length;
    }

    override getState(): number[] {
        return this.values.map(el => el.value);
    }
}
